import React from "react"
import * as styles from "./Styles/Loader.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const listener = (e) => {
  e.preventDefault()
}

const Loader = (props) => {
  if (props.show && props.fullWidth) {
    document.addEventListener("touchmove", listener, { passive: false })
  } else {
    document.removeEventListener("touchmove", listener)
  }
  return (
    <React.Fragment>
      {props.show && props.fullWidth && (
        <div className={styles.overlay}>
          <div
            className={cn(
              "loader",
              props.color ? props.color : "green",
              props.small ? "small" : "large"
            )}
            style={props.style}
          >
            Loading
          </div>
        </div>
      )}
      {props.show && !props.fullWidth && (
        <div
          className={cn(
            "loader",
            props.color ? props.color : "green",
            props.small ? "small" : "large"
          )}
          style={props.style}
        >
          Loading
        </div>
      )}
    </React.Fragment>
  )
}

export default Loader
